var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27.5 27.5",
    style: {
      enableBackground: "new 0 0 27.5 27.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.8,0.5c5.3,0.1,9.7,4,10.4,9.2c0.4,3-0.4,5.7-2.3,8c-1.2,1.4-2.3,2.9-3.4,4.3c-1.1,1.4-2.2,2.9-3.3,4.3 c-0.8,1-1.9,1-2.6,0c-2-2.5-3.9-5-5.9-7.5c-0.3-0.3-0.6-0.6-0.8-1c-4.9-5.9-2-15,5.4-16.9C12,0.7,12.9,0.6,13.8,0.5z M22.5,11 c0-4.8-3.9-8.7-8.7-8.7c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7C18.6,19.7,22.5,15.8,22.5,11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.2,8.9c-0.2,0-0.3,0-0.5,0c-0.5,0-0.7-0.3-0.4-0.8c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.2,0.3-0.3 c-0.3-0.2-0.5-0.4-0.7-0.7c-0.3-0.3-0.3-0.6-0.1-0.8c0.2-0.2,0.5-0.2,0.8,0.1c0.4,0.3,0.7,0.7,1.1,1.1c0.2,0.2,0.3,0.5,0.3,0.8 c0,1.9,0,3.9,0,5.8c0,0.8-0.6,1.4-1.4,1.4c-0.7,0-1.4-0.5-1.4-1.3c0-0.8,0-1.6,0-2.5c0-0.2,0-0.3,0-0.5c0-0.5-0.1-0.5-0.6-0.5 c0,1.6,0,3.1,0,4.7c0.1,0,0.2,0,0.2,0.1c0.3,0.1,0.4,0.3,0.4,0.6c-0.1,0.3-0.2,0.4-0.5,0.4c-0.8,0-1.6,0-2.4,0c-1.3,0-2.7,0-4,0 c-0.4,0-0.6-0.2-0.6-0.5c0-0.3,0.1-0.5,0.5-0.6c0,0,0.1,0,0.1,0c0-0.1,0-0.2,0-0.4c0-2.5,0-5.1,0-7.6c0-1.1,0.2-1.3,1.3-1.3 c1.3,0,2.6,0,3.9,0c0.8,0,1.1,0.4,1.1,1.1c0,0.8,0,1.5,0,2.3c0.1,0,0.2,0,0.3,0c0.9,0.1,1.4,0.6,1.4,1.6c0,0.9,0,1.8,0,2.7 c0,0.2,0,0.5,0.3,0.5c0.3,0,0.3-0.3,0.3-0.5c0-1.5,0-2.9,0-4.4C18.2,9.1,18.2,9,18.2,8.9z M12.7,6.9C12.7,6.9,12.7,6.9,12.7,6.9 c-0.5,0-1,0-1.5,0c-0.4,0-0.5,0.1-0.5,0.5c0,0.7,0,1.5,0,2.2c0,0.4,0.2,0.5,0.6,0.5c1,0,2,0,3,0c0.4,0,0.5-0.2,0.5-0.6 c0-0.7,0-1.4,0-2.1c0-0.4-0.1-0.6-0.6-0.6C13.7,6.9,13.2,6.9,12.7,6.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenter);
export default __webpack_public_path__ + "static/media/center.b03b7cfcda2261d0e144b31b587d20a5.svg";
export { ForwardRef as ReactComponent };